'use client';
import dynamic from 'next/dynamic';
import useBeforeUnload from '@/hooks/useBeforeUnload';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import BackendService from '@/services/backendService';
import { configureConfig } from '@/config';
import ErrorBoundary from '@/components/ErrorBoundary';
import { useDetectBrowserTranslation } from '@/hooks/useDetectBrowserTranslation';
import { NewRelic } from '@/hooks/useNewRelic';

const GameButler = dynamic(() => import('../components/GameButler'), {
  ssr: false,
});

const App = () => {
  useBeforeUnload();
  const { config } = configureConfig();
  useEffect(() => {
    const LocalstorageService = require('@/LocalstorageService').default;
    const IndexedDBStorageService =
      require('@/IndexedDBStorageService').default;

    // Remove any old curipod localstorage cache
    const clearStaleCache = async () => {
      LocalstorageService.clearStaleCache();
      await IndexedDBStorageService.clearStaleCache();
    };
    clearStaleCache();
  }, []);
  const { browserTranslation } = useDetectBrowserTranslation();
  useEffect(() => {
    if (browserTranslation) {
      NewRelic()?.setCustomAttribute('browserTranslation', browserTranslation);
    }
  }, [browserTranslation]);

  useState(() => {
    const bService = new BackendService();
    bService.init(config.backend.coreApiUrl);

    return bService;
  });
  const [queryClient] = useState(() => new QueryClient());

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AppContainer>
          <GameButler />
        </AppContainer>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

const AppContainer = styled.div`
  height: 100%;
  width: 100%;
`;

export default App;
